/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CheckTokenExpirationResponse,
  TokenBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CheckTokenExpirationResponseFromJSON,
    CheckTokenExpirationResponseToJSON,
    TokenBodyFromJSON,
    TokenBodyToJSON,
} from '../models/index';

export interface CreateTokensCheckExpirationRequest {
    tokenBody?: TokenBody;
}

export interface DeleteTokensRequest {
    tokenBody?: TokenBody;
}

/**
 * TokensApi - interface
 * 
 * @export
 * @interface TokensApiInterface
 */
export interface TokensApiInterface {
    /**
     * It takes in a token and returns a boolean if its still active. If the token is still active, then extend the token\'s expiration.
     * @param {TokenBody} [tokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApiInterface
     */
    createTokensCheckExpirationRaw(requestParameters: CreateTokensCheckExpirationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckTokenExpirationResponse>>;

    /**
     * It takes in a token and returns a boolean if its still active. If the token is still active, then extend the token\'s expiration.
     */
    createTokensCheckExpiration(requestParameters: CreateTokensCheckExpirationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckTokenExpirationResponse>;

    /**
     * deletes a token
     * @param {TokenBody} [tokenBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApiInterface
     */
    deleteTokensRaw(requestParameters: DeleteTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * deletes a token
     */
    deleteTokens(requestParameters: DeleteTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class TokensApi extends runtime.BaseAPI implements TokensApiInterface {

    /**
     * It takes in a token and returns a boolean if its still active. If the token is still active, then extend the token\'s expiration.
     */
    async createTokensCheckExpirationRaw(requestParameters: CreateTokensCheckExpirationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckTokenExpirationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/tokens/check-expiration`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TokenBodyToJSON(requestParameters['tokenBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckTokenExpirationResponseFromJSON(jsonValue));
    }

    /**
     * It takes in a token and returns a boolean if its still active. If the token is still active, then extend the token\'s expiration.
     */
    async createTokensCheckExpiration(requestParameters: CreateTokensCheckExpirationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckTokenExpirationResponse> {
        const response = await this.createTokensCheckExpirationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * deletes a token
     */
    async deleteTokensRaw(requestParameters: DeleteTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/tokens`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: TokenBodyToJSON(requestParameters['tokenBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * deletes a token
     */
    async deleteTokens(requestParameters: DeleteTokensRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTokensRaw(requestParameters, initOverrides);
    }

}
